import { NgModule } from '@angular/core';

// ----- Common -----
import { CommonModule } from '@angular/common';

// ----- Forms -----
import { FormsModule } from '@angular/forms';

import { ContractorSetupComponent } from './contractor-setup.component';

// ----- Kendo-Grid Module -----
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';

import {ContractorDetailsService} from '../../services/contractor-details.service'

@NgModule({
  imports: [
    CommonModule, FormsModule, GridModule, ExcelModule
  ],
  declarations: [
    ContractorSetupComponent
  ],
  exports: [
    ContractorSetupComponent
  ],
  providers: [
    ContractorDetailsService
  ]
})
export class ContractorSetupModule { }
